import React from "react";
import "./AIRecommended.css";

const AIRecommended = () => {
  return (
    <div className="airecommended-content">
      <div className="coming-soon-container">
        <h1 className="coming-soon-title">This feature is currently in beta testing.</h1>
        <h2 className="coming-soon-message">Access will be granted soon.</h2>
      </div>
    </div>
  );
};

export default AIRecommended;
